export const maxGodisnjiOdvozKartica = (data) => {
  let max = 0;
  data.forEach((item) => {
    max = Math.max(max, item.mjesovitiKartica);
  });

  return max;
};
